export default [{
    path: 'aiIndex',
    name: 'AI',
    meta: {
        showFooter: true
    },
    component: () => import('../../views/ai/index.vue')
}];
